// /* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
//  * Unauthorized copying of this file, via any medium is strictly prohibited
//  * Proprietary and confidential
//  * Written by Aetonix, Augest 28, 2018
//  * For information or permission request, email info@aetonixsystems.com
//  */

var Model = require("../types/Model.js");

module.exports = Model({
	name: "managedstatuses",
	init: init,
	uninit: uninit,
	listeners: listeners,
	_who_tracker: null,
	_tracking: null,
	_ready: false,

	refresh: refresh,
	listen_for_changes: listen_for_changes
});

function init() {
	this._group_tracker = this.dispatcher.createTracker();
	this._who_tracker = this.dispatcher.createTracker();
	this._tracking = [];

	this.push({});
}

function uninit() {
	this._tracking = null;
	this._group_tracker.off();
	this._group_tracker = null;
	this._who_tracker.off();
	this._who_tracker = null;
}

function listeners() {
	return {
		"connectivity:online": refresh,
		"loadchecker:ready": initial_load,
		"activemanagegroup:updated": update_active_group
	};
}

function initial_load() {
	this._ready = true;
	this.refresh();
}

function refresh() {
	var group = this._group;
	if(!this._ready) return;
	this.emit("save:trigger:start");
	return this.api.manage.status.list(group)
		.then(set_status.bind(this))
		.then(trackAdded.bind(this))
		.catch(console.error.bind(console))
		.then(finish_load.bind(this));
}

function trackAdded(){
	var group = this._group;
	var groupTracker = this._group_tracker;

	groupTracker.off();

	if(group)
		groupTracker.on(`mqtt:managegroup/${group}/patient/added`, refresh.bind(this));
	else
		groupTracker.on("mqtt:$/manage/added", refresh.bind(this));
}

function finish_load() {
	this.emit("save:trigger:finish");
}

function set_status(statuses) {
	var data = statuses.reduce(function(result, status) {
		result[status._id] = status;
		this.listen_for_changes(status._id);
		return result;
	}.bind(this), {});

	this.push(data);
}
function listen_for_changes(who) {
	var tracking = this._tracking;
	if(tracking.indexOf(who) !== -1) return;
	this._tracking.push(who);
	var tracker = this._who_tracker;

	var group = this._group;

	if(group){
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/observations/status/updated", refresh.bind(this));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/workflow/status/updated", refresh.bind(this));
		tracker.on("mqtt:managegroup/" + group + "/patient/u/" + who + "/workflow/current_status/updated", refresh.bind(this));
	} else {
		tracker.on("mqtt:u/" + who + "/observations/status/updated", refresh.bind(this));
		tracker.on("mqtt:u/" + who + "/workflow/status/updated", refresh.bind(this));
		tracker.on("mqtt:u/" + who + "/workflow/current_status/updated", refresh.bind(this));
	}
}

function update_active_group(group){
	this._who_tracker.off();
	this._tracking = [];
	this._group = group;
	this.refresh();
}